import React from 'react';
import { Mail, FileText, DollarSign, Trash2 } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const categoryIcons = {
  appointment: Mail,
  invoice: DollarSign,
  general: FileText
};

const categoryColors = {
  appointment: 'bg-blue-100 text-blue-700',
  invoice: 'bg-green-100 text-green-700',
  general: 'bg-gray-100 text-gray-700'
};

export default function TemplateList({ templates, selectedTemplate, onSelect, onDelete }) {
  const groupedTemplates = templates?.reduce((acc, template) => {
    if (!acc?.[template?.category]) {
      acc[template.category] = [];
    }
    acc?.[template?.category]?.push(template);
    return acc;
  }, {});

  return (
    <div className="divide-y divide-gray-200">
      {Object.keys(groupedTemplates || {})?.map((category) => {
        const Icon = categoryIcons?.[category] || FileText;
        
        return (
          <div key={category} className="p-4">
            <div className="flex items-center gap-2 mb-3">
              <Icon className="w-4 h-4 text-gray-500" />
              <h3 className="text-sm font-semibold text-gray-900 capitalize">
                {category}
              </h3>
              <span className="text-xs text-gray-500">
                ({groupedTemplates?.[category]?.length})
              </span>
            </div>
            <div className="space-y-2">
              {groupedTemplates?.[category]?.map((template) => (
                <div
                  key={template?.id}
                  onClick={() => onSelect(template)}
                  className={`group relative p-3 rounded-lg border cursor-pointer transition-all ${
                    selectedTemplate?.id === template?.id
                      ? 'border-indigo-500 bg-indigo-50' :'border-gray-200 hover:border-gray-300 hover:bg-gray-50'
                  }`}
                >
                  <div className="flex items-start justify-between">
                    <div className="flex-1 min-w-0">
                      <h4 className="text-sm font-medium text-gray-900 truncate">
                        {template?.name}
                      </h4>
                      <p className="text-xs text-gray-500 mt-1 line-clamp-2">
                        {template?.subject}
                      </p>
                      
                      <div className="flex items-center gap-2 mt-2">
                        <span
                          className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${
                            categoryColors?.[template?.category]
                          }`}
                        >
                          {template?.category}
                        </span>
                        
                        {!template?.isActive && (
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-700">
                            Inactive
                          </span>
                        )}
                      </div>
                    </div>

                    <button
                      onClick={(e) => {
                        e?.stopPropagation();
                        onDelete(template?.id);
                      }}
                      className="opacity-0 group-hover:opacity-100 transition-opacity p-1 hover:bg-red-50 rounded"
                    >
                      <Trash2 className="w-4 h-4 text-red-600" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
      {(!templates || templates?.length === 0) && (
        <div className="p-8 text-center">
          <FileText className="w-12 h-12 text-gray-400 mx-auto mb-3" />
          <p className="text-sm text-gray-500">No templates yet</p>
          <p className="text-xs text-gray-400 mt-1">
            Create your first template to get started
          </p>
        </div>
      )}
    </div>
  );
}